<template>
  <div class="col-xs-12 flight-segment clearfix">
    <div class="row col-xs-4 flight-segment-info">
      <p class="flight-segment-text-info text-right">
        <i class="fa fa-clock-o fa-fw ico-clock"></i>
        Duração:<br class="visible-xs-block"> {{ segment.flight_time | minutesToHours }}
      </p>
      <p class="flight-segment-text-info text-right">
        <i class="fa fa-plane ico-plane"></i>&nbsp;
        <span class="hidden-xs">Número do voo:</span>
        <span class="hidden-sm hidden-md hidden-lg">Voo:</span>
          <strong>&nbsp;{{ segment.carrier.iata_code }}{{ segment.flight_number | normalizeFlightNumber }}</strong>
      </p>
    </div>

    <div class="row col-xs-8 flight-segment-panel">
      <span
        v-if="indexKey > 0"
        class="flight-segment-mark-index">{{ indexKey }}</span>
      <div class="flight-segment-row">
        <div class="clearfix">
          <div class="col-sm-2">
            <p class="flight-segment-text-info">
              <strong>Partida</strong>
            </p>
          </div>
          <div class="col-sm-10">
            <p class="flight-segment-text-info">
              {{ segment.date_departure | dateToWeekday }}
            </p>
          </div>
        </div>
      </div>

      <div class="flight-segment-mark-down">
        <div class="clearfix">
          <div class="col-sm-2 flight-segment-mark">
            <p class="flight-segment-text-main">
              {{ segment.date_departure | dateToHour }}<sup v-if="dateDiffDeparture > 0">+{{ dateDiffDeparture }}</sup>
            </p>
          </div>
          <div class="col-sm-10">
            <p class="flight-segment-text-main">
              <strong>{{ segment.origin.iata_code }}</strong> {{ segment.origin.name }}
            </p>
          </div>
        </div>
      </div>

      <div class="flight-segment-row flight-segment-mark-mid">
        <div class="clearfix">
          <div class="col-sm-2">
            <p class="flight-segment-text-info">
              <strong>Chegada</strong>
            </p>
          </div>
          <div class="col-sm-10">
            <p class="flight-segment-text-info">
              {{ segment.date_arrival | dateToWeekday }}
            </p>
          </div>
        </div>
      </div>

      <div class="">
        <div class="clearfix">
          <div class="col-sm-2 flight-segment-mark flight-segment-mark-up">
            <p class="flight-segment-text-main">
              {{ segment.date_arrival | dateToHour }}<sup v-if="dateDiffArrival > 0">+{{ dateDiffArrival }}</sup>
            </p>
          </div>
          <div class="col-sm-10">
            <p class="flight-segment-text-main">
              <strong>{{ segment.destination.iata_code }}</strong> {{ segment.destination.name }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  props: [
    'segment',
    'indexKey',
    'dateDeparture'
  ],
  data() {
    return {
      dateDiffDeparture: this.diffDate(this.segment.date_departure),
      dateDiffArrival: this.diffDate(this.segment.date_arrival)
    }
  },
  methods: {
    diffDate (date) {
      return moment(date, 'YYYY, MM, DD').diff(moment(this.dateDeparture, 'YYYY, MM, DD'), 'days')
    }
  }
};
</script>

<style lang="scss">
@import '@/scss/components/flight/FlightSegment';
</style>
